import React from "react";

import { PartnerAccountDialog } from "features/Partners/components/PartnerAccountDialog";
import { PartnerFormDialog } from "features/Partners/components/PartnerFormDialog";
import { Banner } from "shared/ui/Banner";
import { Button } from "shared/ui/Button";
import { ConfirmDialog } from "shared/ui/ConfirmDialog";
import { NotificationSnackbar } from "shared/ui/NotificationSnackbar";
import { Skeleton } from "shared/ui/Skeleton";
import { Tabs } from "shared/ui/Tabs";

import { PartnerBranchesTab } from "./components/tabs/PartnerBranchesTab";
import { PartnerInfoTab } from "./components/tabs/PartnerInfoTab";
import { PartnerPayoutsTab } from "./components/tabs/PartnerPayoutsTab";
import { PartnerDetailsTab, TABS } from "./constants";
import { usePartnerDetailsState } from "./hooks/usePartnerDetailsState";
import { Name, TabContent } from "./styles";

interface PartnerDetailsProps {
    partnerId: number;
}

export const PartnerDetails = ({ partnerId }: PartnerDetailsProps) => {
    const state = usePartnerDetailsState(partnerId);

    if (state.loading) return <Skeleton height="320px" />;

    if (!state.partner) {
        return (
            <Banner tone="danger" title="Партнёр не найден">
                <Button size="small" variant="outlined" color="neutral" onClick={state.onRetry}>
                    Повторить
                </Button>
            </Banner>
        );
    }

    const { partner } = state;

    const renderTab = () => {
        if (state.tab === "branches") return <PartnerBranchesTab partnerId={partner.id} />;

        if (state.tab === "payouts") return <PartnerPayoutsTab partner={partner} notify={state.notify} />;

        return <PartnerInfoTab partner={partner} onOpenDialog={state.onOpenDialog} />;
    };

    return (
        <>
            <Name>{partner.name}</Name>

            <Tabs<PartnerDetailsTab> value={state.tab} tabs={TABS} onChange={state.onChangeTab} />
            <TabContent>{renderTab()}</TabContent>

            {state.dialog === "edit" && (
                <PartnerFormDialog
                    partner={partner}
                    saving={state.saving}
                    onClose={state.onCloseDialog}
                    onSubmit={state.onSaveForm}
                />
            )}

            {state.dialog === "account" && (
                <PartnerAccountDialog
                    partner={partner}
                    saving={state.saving}
                    onClose={state.onCloseDialog}
                    onSubmit={state.onSaveAccount}
                />
            )}

            {state.dialog === "delete" && (
                <ConfirmDialog
                    open
                    title="Удалить партнёра?"
                    description={`${partner.name} потеряет доступ в админку. Партнёра с заведениями или выплатами удалить нельзя.`}
                    confirmLabel="Удалить"
                    tone="danger"
                    saving={state.saving}
                    onClose={state.onCloseDialog}
                    onConfirm={state.onConfirmDelete}
                />
            )}

            <NotificationSnackbar {...state.notify.snackbarProps} />
        </>
    );
};
